import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appCustomizedTableCellHost]',
})
export class CustomizedTableCellDirective {
  public constructor(public readonly viewContainerRef: ViewContainerRef) {}
}
